export class PersonIncoming {
    login: string;
    password: string;
}

export class Person {
    login: string;
    password: string;
}

export class BusinessRole {
    business: string;
    role: string;
}


    export class BusinessOutcoming
    {
         constr: string;
}
        
   

export class MainBar {
    mb_id: number;
    mb_order_id: number;
    mb_name: string;
    mb_active: number;
    mb_is_enabled_role: number;
    mb_password_type: number;
    icon: string;
    password?: string;
    mb_router_link: string;
}

export class TopBar {
    tb_order_id: number;
    tb_name: string;
    tb_is_enabled_role: number;
    icon_name: string;
    link: string
}

export class Control {
    cb_id: number;
    cb_ctrl_type?: number;
    cb_is_blurry_role?: number;
    cb_is_enabled_role?: number;
    cb_password_type?: number;
    password?: string;
    cb_is_visible_role?: number;
}

export class Screen {
    screen_id: number;
}